import { render, staticRenderFns } from "./StreamerStats.vue?vue&type=template&id=adee0154&scoped=true"
import script from "./StreamerStats.vue?vue&type=script&lang=js"
export * from "./StreamerStats.vue?vue&type=script&lang=js"
import style0 from "./StreamerStats.vue?vue&type=style&index=0&id=adee0154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adee0154",
  null
  
)

export default component.exports